import React, { useState } from 'react';
import { machineGallery } from '../mock';
import { ImageLightbox } from './ImageLightbox';

export const Technical = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  // Duplicate images for seamless infinite scroll
  const duplicatedImages = [...machineGallery, ...machineGallery, ...machineGallery];

  const openLightbox = (index) => {
    // Calculate the actual index in the original array
    const actualIndex = index % machineGallery.length;
    setCurrentImageIndex(actualIndex);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setCurrentImageIndex(null);
  };

  const showNext = () => {
    setCurrentImageIndex((prev) => (prev + 1) % machineGallery.length);
  };

  const showPrev = () => {
    setCurrentImageIndex((prev) => (prev - 1 + machineGallery.length) % machineGallery.length);
  };

  return (
    <section id="technical" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Technical
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Explore our precision-engineered vulcanizing machines and components designed for 
            industrial excellence. Click on any image to view in detail.
          </p>
        </div>

        {/* Image Carousel */}
        <div className="overflow-hidden">
          <div className="machine-gallery-track">
            {duplicatedImages.map((image, index) => (
              <div
                key={`${image.id}-${index}`}
                className="machine-gallery-item"
                onClick={() => openLightbox(index)}
              >
                <img
                  src={image.image}
                  alt={image.title}
                  className="w-full h-full object-cover cursor-pointer"
                />
                <div className="machine-gallery-overlay">
                  <p className="text-white font-semibold text-sm">{image.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <ImageLightbox
          images={machineGallery}
          currentIndex={currentImageIndex}
          onClose={closeLightbox}
          onNext={showNext}
          onPrev={showPrev}
        />
      )}
    </section>
  );
};
